import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { allIcons } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const CustomerSupportDialog = forwardRef(
  ({ open, onClose, form, onChange, onSubmit }, ref) => {
    useImperativeHandle(ref, () => ({
      isVisible: () => {},
      handleSubmitExternally: () => onSubmit(),
      getForm: () => form,
      setFormField: (key, value) => onChange(key, value),
      resetForm: () =>
        onChange("all", {
          name: "",
          email: "",
          phone: "",
          message: "",
          code: "",
        }),
    }));

    return (
      <BootstrapDialog onClose={onClose} open={open}>
        <Stack
          p={2}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" gap={2}>
            <img
              src={allIcons.landingHeadphoneIcon}
              alt="Headphone-icon"
              width={35}
            />
            <Box>
              <Typography
                variant="h1"
                fontSize="1.125rem"
                color="primary.main"
                fontWeight={600}
              >
                Live Support
              </Typography>
              <Typography variant="body2" color="#868E96">
                24/7 we are available
              </Typography>
            </Box>
          </Stack>
          <IconButton onClick={onClose}>
            <img src={allIcons.crossBoldIcon} width={25} />
          </IconButton>
        </Stack>

        <DialogContent dividers>
          <Typography variant="h5" fontWeight={700} textAlign="center">
            Contact Us Over
          </Typography>

          <Stack>
            <Chip
              sx={{
                my: 2,
                border: "1px solid #08AD36",
                "& .MuiChip-label": { color: "#08AD36" },
              }}
              avatar={
                <Avatar alt="WhatsApp" src={allIcons.whatsAppLogoColor} />
              }
              label="WhatsApp"
              variant="outlined"
              onClick={() =>
                window.open("https://wa.me/966536651383", "_blank")
              }
            />
          </Stack>

          <Box
            component="form"
            onSubmit={onSubmit}
            sx={{ maxWidth: 400, margin: "auto" }}
          >
            <Grid container spacing={2} my={2} mb={4}>
              <Grid item xs={12}>
                <Label labelText="Name" required />
                <TextInput
                  placeholder="Enter your name"
                  value={form?.name}
                  onChange={(e) => onChange("name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Label labelText="Email address" required />
                <TextInput
                  placeholder="Enter your email address"
                  value={form?.email}
                  onChange={(e) => onChange("email", e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Label labelText="Phone Number" required />
                <PhoneInput
                  country="us"
                  value={form?.phone}
                  onChange={(phone) => onChange("phone", phone)}
                  inputClass="cutom-phone-input"
                  buttonClass="custom-phone-input-button"
                />
              </Grid>
              <Grid item xs={12}>
                <Label labelText="Your Message" required />
                <TextInput
                  placeholder="Enter your message"
                  multiline
                  rows={4}
                  value={form?.message}
                  onChange={(e) => onChange("message", e.target.value)}
                />
              </Grid>
            </Grid>

            <GlobalButton btnText="Send" handleClickBtn={onSubmit} />
          </Box>
        </DialogContent>
      </BootstrapDialog>
    );
  }
);

export default CustomerSupportDialog;
